// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__V-onV","footerInner":"footer_footerInner__MJ2P2"};